import {z} from "zod";
import {ManagerInformationModel} from "../../tax-corporation";
import {HalfYearModel} from "./HalfYearModel";

const schema = z.object({
	department: z.string(),
	managerInformation: ManagerInformationModel.model.nullable(),
	halfYears: z.array(HalfYearModel.model),
	insuranceFeeTarget: z.number().nullable(),
	insuranceFeeActual: z.number().nullable(),
	insuranceFeeResultRate: z.number().nullable(),
	totalSalesRadio: z.number().nullable()
});

const model = schema.transform((values) => ({
	...values
}));

export const NormalInsuranceModel = {schema, model};
export type INormalInsuranceModel = z.infer<typeof NormalInsuranceModel.model>;
export const DEFAULT_NORMAL_INSURANCE: INormalInsuranceModel = {
	department: "",
	managerInformation: null,
	halfYears: [],
	insuranceFeeTarget: 0,
	insuranceFeeActual: 0,
	insuranceFeeResultRate: 0,
	totalSalesRadio: 0
};
